import { cn } from "../../lib/utils.ts";

export const FLOATING_ACTION_CLASS =
    "h-(--floating-action-height) w-auto rounded-full px-5 text-sm font-semibold text-doberman-black transition-transform active:scale-[0.96] focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-doberman-black motion-reduce:active:scale-100";

export function MobileFloatingAction({
    className,
    ...props
}: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="mobile-floating-action"
            className={cn(
                "fixed right-[max(0.75rem,env(safe-area-inset-right))] bottom-[calc(0.75rem+env(safe-area-inset-bottom))] z-40 max-w-[calc(100%-1.5rem)] drop-shadow-md md:hidden",
                className,
            )}
            {...props}
        />
    );
}
